import {scheduleConflicts} from "./scheduling/conflicts";
import {agendaDirectory} from "./access/patientDirectory";
import {patientDirectory} from "./access/patientDirectory";
import {isClinicalProvider} from "./access/policy";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import { storage, auth } from "./firebase";
import {
  ref,
  uploadString,
  getDownloadURL
} from "firebase/storage";
import { createPortal } from "react-dom";
import { db } from "./firebase";
import { useClinic } from "./context/ClinicContext";
import {
  getDoc,
  getDocs
} from "./access/firestore";
import {
  collection,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  query,
  where,
  serverTimestamp,
  onSnapshot
} from "./access/firestore";
import PacienteForm from "./PacienteForm";
import logAction
  from "./utils/logAction";
import {
  findBestPatientMatch
} from "./utils/patientMatcher";
import ConfirmDialog from "./components/ConfirmDialog";
import { createAppointment } from "./services/createAppointment";
import {
  CalendarDays,
  CalendarPlus,
  PencilLine,
  Clock3,
  User,
  AlertTriangle,
  X
} from "lucide-react";
import EvolutionCard from "./EvolutionCard";
import {
  buildScheduledAt,
  getDeviceTimeZone,
  getScheduleLocalFields,
  localizeScheduleEntry
} from "./utils/timezone";

const EMPTY_ITEMS = [];

export default function CitaForm({
  paciente,
  cita,
  onClose,
  bloqueos = EMPTY_ITEMS
}) {
  const {
    clinicId,
    clinicData
  } = useClinic();

  const deviceTimeZone = getDeviceTimeZone();
  const initialBloqueoLocal =
    cita?.tipo === "bloqueoAgenda"
      ? getScheduleLocalFields(cita, deviceTimeZone)
      : null;

  const isMobile =
    typeof window !== "undefined" &&
    window.innerWidth <= 768;
  
    const [modoFormulario, setModoFormulario] =
    useState(
      cita?.tipo === "bloqueoAgenda"
        ? "bloqueo"
        : "cita"
    );

  const [bloqueo, setBloqueo] = useState({
    motivo: cita?.tipo === "bloqueoAgenda"
      ? cita.motivo || ""
      : "",
    descripcion: cita?.tipo === "bloqueoAgenda"
      ? cita.descripcion || ""
      : "",
    fecha: cita?.tipo === "bloqueoAgenda"
      ? initialBloqueoLocal?.fecha || cita.fecha || ""
      : "",
    horaInicio: cita?.tipo === "bloqueoAgenda"
      ? initialBloqueoLocal?.horaInicio || cita.horaInicio || "09:00"
      : "09:00",
    horaFin: cita?.tipo === "bloqueoAgenda"
      ? initialBloqueoLocal?.horaFin || cita.horaFin || "12:00"
      : "12:00",
    doctorId: cita?.tipo === "bloqueoAgenda"
      ? cita.doctorId || ""
      : "",
    doctorNombre: cita?.tipo === "bloqueoAgenda"
      ? cita.doctorNombre || ""
      : "",
    alcance: cita?.tipo === "bloqueoAgenda"
      ? cita.alcance || "doctor"
      : "doctor"
  });

  const [guardandoBloqueo, setGuardandoBloqueo] =
    useState(false);

  const [pacientes, setPacientes] =
    useState([]);

  const [doctores, setDoctores] =
    useState([]);

  const [agenda, setAgenda] = useState({clinicId:null,items:[],ready:false});
  const citasExistentes = agenda.clinicId === clinicId ? agenda.items : EMPTY_ITEMS;
  const agendaLista = agenda.clinicId === clinicId && agenda.ready;
  const [guardandoCita,setGuardandoCita] = useState(false);
  const guardandoCitaRef = useRef(false);
  const [alertaParaKey,setAlertaParaKey] = useState("");

  const [mostrarAlertaHorario, setMostrarAlertaHorario] =
    useState(false);

  const [mostrarAlternativasHorario, setMostrarAlternativasHorario] =
    useState(false);



  const [alternativasHorario, setAlternativasHorario] =
    useState([]);

  const [conflictoAceptadoKey, setConflictoAceptadoKey] =
    useState("");

  const [busqueda, setBusqueda] =
    useState("");

  const [mostrarLista, setMostrarLista] =
    useState(false);

  const [
    pacienteSeleccionado,
    setPacienteSeleccionado
  ] = useState(
    paciente || null
  );

  const [
    showPacienteForm,
    setShowPacienteForm
  ] = useState(false);

  const [mostrarSelectorHora, setMostrarSelectorHora] =
    useState(false);

  const [horaSelector, setHoraSelector] =
    useState("12");

  const [minutoSelector, setMinutoSelector] =
    useState("00");

  const [periodoSelector, setPeriodoSelector] =
    useState("PM");

  const [form, setForm] =
    useState({
      fecha: "",
      hora: "",
      motivo: "",
      presupuesto: "",
      duracion:
        clinicData
          ?.defaultAppointmentDuration ||
        "60",
      notas: "",
      proximo: "",
      estado: "activa",
      doctorId: "",
      doctorNombre: "",
      doctorColor: "#3b82f6"
    });

  const signatureRef = useRef(null);

  const [firmaVacia, setFirmaVacia] =
    useState(true);

  const [guardandoEvolucion, setGuardandoEvolucion] =
    useState(false);
  
  const [mostrarEvolucionEnCita, setMostrarEvolucionEnCita] =
    useState(false);
  
  const abrirEvolucionAlGuardarRef = useRef(false);

  const [showConfirm, setShowConfirm] =
    useState(false);

  const [
    showDeleteAppointmentConfirm,
    setShowDeleteAppointmentConfirm
  ] = useState(false);

  const [
    showDeleteBlockConfirm,
    setShowDeleteBlockConfirm
  ] = useState(false);

  const [
    eliminandoBloqueo,
    setEliminandoBloqueo
  ] = useState(false);

  const [
    showPastDateWarning,
    setShowPastDateWarning
  ] = useState(false);

  const [
    mostrarAlertaFechaAnterior,
    setMostrarAlertaFechaAnterior
  ] = useState(false);

  const [
    continuarFechaAnterior,
    setContinuarFechaAnterior
  ] = useState(null);

  const [
    enviarNotificacionWhatsApp,
    setEnviarNotificacionWhatsApp
  ] = useState(true);

  // =========================
  // CARGAR PACIENTES
  // =========================

  useEffect(() => {
    if (!clinicId) return;

    return onSnapshot(
      patientDirectory(db,clinicId),
      snap => {
        setPacientes(
          snap.docs.map(d => ({
            id: d.id,
            ...d.data()
          }))
        );
      }
    );
  }, [clinicId]);

  // =========================
  // CARGAR DOCTORES
  // =========================

  useEffect(() => {
    if (!clinicId) return;

    const cargarDoctores =
      async () => {
        try {
          const snap =
            await getDocs(
              collection(
                db,
                "clinics",
                clinicId,
                "teamDirectory"
              )
            );

          const docs =
            snap.docs.map(d => ({
              id: d.id,
              ...d.data()
            }));

          setDoctores(
            docs.filter(u =>
              isClinicalProvider(u)
            )
          );
        } catch (err) {
          console.error(err);
        }
      };

    cargarDoctores();
  }, [clinicId]);


  // =========================
  // CARGAR CITAS DE LA CLÍNICA
  // =========================

  useEffect(() => {
    let active = true;
    setAgenda({clinicId,items:[],ready:false});
    if (!clinicId) return;
    const unsubscribe = onSnapshot(
      agendaDirectory(db,clinicId),
      {includeMetadataChanges:true},
      snapshot => {
        if(active) {
          setAgenda({
            clinicId,
            items: snapshot.docs.map(d =>
              localizeScheduleEntry({ id: d.id, ...d.data() }, deviceTimeZone)
            ),
            ready: !snapshot.metadata?.fromCache
          });
        }
      },
      () => {if(active)setAgenda({clinicId,items:[],ready:false});}
    );
    return () => {active=false;unsubscribe();};
  }, [clinicId, deviceTimeZone]);

  const obtenerMinutosHora = hora => {
    if (!hora || !/^\d{2}:\d{2}$/.test(hora)) {
      return null;
    }

    const [horas, minutos] = hora.split(":").map(Number);

    if (horas > 23 || minutos > 59) {
      return null;
    }

    return horas * 60 + minutos;
  };

  const obtenerDuracionMinutos = duracion => {
    const minutos = Number.parseInt(
      String(duracion || "60"),
      10
    );

    return Number.isFinite(minutos) && minutos > 0
      ? minutos
      : 60;
  };

  const citaEstaCancelada = estado =>
    [
      "cancelada",
      "cancelado",
      "canceled",
      "cancelled"
    ].includes(
      String(estado || "").toLowerCase()
    );

  const horarioEstaDisponible = useCallback((fecha,hora,duracion) => {
    const start=obtenerMinutosHora(hora);
    return start !== null && start + obtenerDuracionMinutos(duracion) <= 1440 && scheduleConflicts({date:fecha,time:hora,duration:duracion,defaultDuration:clinicData?.defaultAppointmentDuration,doctorId:form.doctorId,excludeId:cita?.id,appointments:citasExistentes,blocks:bloqueos}).length===0;
  },[clinicData?.defaultAppointmentDuration,form.doctorId,cita?.id,citasExistentes,bloqueos]);
  
  // =========================
  // DETECTAR BLOQUEOS DE AGENDA
  // =========================

  const bloqueoAplicaADoctor = bloqueo => {
    if (bloqueo.alcance === "todos") {
      return true;
    }

    // Un bloqueo individual afecta al doctor seleccionado.
    if (bloqueo.alcance === "doctor") {
      return Boolean(
        form.doctorId &&
        bloqueo.doctorId === form.doctorId
      );
    }

    return false;
  };

  const horarioChocaConBloqueo = (
    fecha,
    hora,
    duracion,
    bloqueo
  ) => {
    if (
      !bloqueo ||
      bloqueo.fecha !== fecha ||
      !bloqueo.horaInicio ||
      !bloqueo.horaFin ||
      !bloqueoAplicaADoctor(bloqueo)
    ) {
      return false;
    }

    const inicioNuevo = obtenerMinutosHora(hora);
    const inicioBloqueo = obtenerMinutosHora(
      bloqueo.horaInicio
    );
    const finBloqueo = obtenerMinutosHora(
      bloqueo.horaFin
    );

    if (
      inicioNuevo === null ||
      inicioBloqueo === null ||
      finBloqueo === null
    ) {
      return false;
    }

    const finNuevo =
      inicioNuevo + obtenerDuracionMinutos(duracion);

    // Dos intervalos se traslapan si uno comienza
    // antes de que termine el otro.
    return (
      inicioNuevo < finBloqueo &&
      finNuevo > inicioBloqueo
    );
  };

  const obtenerBloqueosEnConflicto = (
    fecha,
    hora,
    duracion
  ) => {
    return bloqueos.filter(bloqueo =>
      horarioChocaConBloqueo(
        fecha,
        hora,
        duracion,
        bloqueo
      )
    );
  };
  
  const conflictosHorario = useMemo(() => !agendaLista || guardandoCita || modoFormulario === "bloqueo" ? [] : scheduleConflicts({
    date:form.fecha,time:form.hora,duration:form.duracion || clinicData?.defaultAppointmentDuration,defaultDuration:clinicData?.defaultAppointmentDuration,
    doctorId:form.doctorId,excludeId:cita?.id,appointments:citasExistentes,blocks:bloqueos
  }),[agendaLista,guardandoCita,modoFormulario,form.fecha,form.hora,form.duracion,form.doctorId,cita?.id,citasExistentes,bloqueos,clinicData?.defaultAppointmentDuration]);
  const horarioActualKey = JSON.stringify([clinicId,form.fecha,form.hora,form.duracion,form.doctorId,conflictosHorario.map(item=>[item.id,item.tipo,item.hora,item.duracion,item.horaInicio,item.horaFin])]);

  // =========================
  // DETECTAR HORARIOS OCUPADOS
  // =========================

    useEffect(() => {
    // Al crear o editar un bloqueo no se debe mostrar
    // la alerta de conflictos de citas.
    if (modoFormulario === "bloqueo") {
      setAlternativasHorario([]);
      setMostrarAlertaHorario(false);
      setMostrarAlternativasHorario(false);
      return;
    }

    if (!form.fecha || !form.hora) {
      setAlternativasHorario([]);
      setMostrarAlertaHorario(false);
      setMostrarAlternativasHorario(false);
      return;
    }

    const inicioNuevo = obtenerMinutosHora(form.hora);

    if (inicioNuevo === null) {
      return;
    }

    const duracionNueva = obtenerDuracionMinutos(
      form.duracion ||
      clinicData?.defaultAppointmentDuration
    );

    

    const conflictos = conflictosHorario;
    const conflictosBloqueos = conflictos.filter(item=>item.tipo === "bloqueoAgenda");

    if (conflictos.length === 0) {
      setAlternativasHorario([]);
      setMostrarAlertaHorario(false);
      setMostrarAlternativasHorario(false);
      return;
    }

    if (
      horarioActualKey === conflictoAceptadoKey &&
      conflictosBloqueos.length === 0
    ) {
      setMostrarAlertaHorario(false);
      return;
    }

    // Alinear la búsqueda a intervalos de 30 minutos.
    const horaRedondeada =
      Math.floor(inicioNuevo / 30) * 30;

    const anteriores = [];
    const posteriores = [];

    // Buscar en ambas direcciones durante el día completo.
    // Así no se excluyen opciones posteriores por haber
    // encontrado demasiados horarios anteriores.
    for (
      let distancia = 30;
      distancia <= 720;
      distancia += 30
    ) {
      const inicioAnterior =
        horaRedondeada - distancia;

      const inicioPosterior =
        horaRedondeada + distancia;

      const evaluarHorario = (
        inicioCandidato,
        destino
      ) => {
        if (
          inicioCandidato < 0 ||
          inicioCandidato + duracionNueva > 1440
        ) {
          return;
        }

        const horaCandidata =
          `${String(
            Math.floor(inicioCandidato / 60)
          ).padStart(2, "0")}:${String(
            inicioCandidato % 60
          ).padStart(2, "0")}`;

        if (
          horarioEstaDisponible(
            form.fecha,
            horaCandidata,
            duracionNueva
          )
        ) {
          destino.push({
            fecha: form.fecha,
            hora: horaCandidata
          });
        }
      };

      evaluarHorario(inicioAnterior, anteriores);
      evaluarHorario(inicioPosterior, posteriores);
    }

    // Tomar primero las tres opciones más cercanas
    // de cada lado.
    const opcionesAnteriores = anteriores.slice(0, 3);
    const opcionesPosteriores = posteriores.slice(0, 3);

    let opciones = [
      ...opcionesAnteriores,
      ...opcionesPosteriores
    ];

    // Si un lado no tiene suficientes espacios libres,
    // completar con los más cercanos del lado restante.
    if (opciones.length < 6) {
      const restantes = [
        ...anteriores.slice(3),
        ...posteriores.slice(3)
      ];

      restantes.sort((a, b) =>
        Math.abs(
          obtenerMinutosHora(a.hora) - inicioNuevo
        ) -
        Math.abs(
          obtenerMinutosHora(b.hora) - inicioNuevo
        )
      );

      opciones = [
        ...opciones,
        ...restantes.slice(0, 6 - opciones.length)
      ];
    }

    // Mostrar las opciones en orden cronológico.
    opciones.sort((a, b) =>
      obtenerMinutosHora(a.hora) -
      obtenerMinutosHora(b.hora)
    );

    setAlternativasHorario(opciones);
    setAlertaParaKey(horarioActualKey);
    setMostrarAlertaHorario(true);
    setMostrarAlternativasHorario(false);
  }, [
    form.fecha,
    form.hora,
    form.duracion,
    form.doctorId,
    citasExistentes,
    bloqueos,
    cita?.id,
    clinicData?.defaultAppointmentDuration,
    conflictoAceptadoKey,
    modoFormulario,
    horarioActualKey,
    agendaLista,
    guardandoCita,
    conflictosHorario,
    horarioEstaDisponible
  ]);

  // =========================
  // EDITAR CITA
  // =========================

  useEffect(() => {
    if (!cita) return;

    setForm({
      ...(() => {
        const local = getScheduleLocalFields(cita, deviceTimeZone);
        return {
          fecha: local.fecha || "",
          hora: local.hora || ""
        };
      })(),

      motivo:
        cita.motivo || "",

      tratamiento:
        cita.tratamiento || "",

      presupuesto:
        cita.presupuesto || "",

      duracion:
        cita.duracion || "",

      notas:
        cita.notas || "",

      proximo:
        cita.proximo || "",

      estado:
        cita.estado || "activa",

      doctorId:
        cita.doctorId || "",

      doctorNombre:
        cita.doctorNombre || "",

      doctorColor:
        cita.doctorColor || "#3b82f6"
    });

    const pacienteCompleto =
      pacientes.find(
        p => p.id === cita.pacienteId
      );

    if (pacienteCompleto) {
      setPacienteSeleccionado(
        pacienteCompleto
      );
    } else if (cita.pacienteId) {
      setPacienteSeleccionado({
        id: cita.pacienteId,

        nombre:
          cita.pacienteNombre
            ?.split(" ")[0] || "",

        apellidos:
          cita.pacienteNombre
            ?.split(" ")
            .slice(1)
            .join(" ") || ""
      });
    } else {
      setPacienteSeleccionado(null);
    }

    setBusqueda(
      cita.pacienteNombre || ""
    );
  }, [
    cita,
    pacientes,
    deviceTimeZone
  ]);

  // =========================
  // CITA IMPORTADA DE GOOGLE
  // =========================

  const importedFromGoogle =
    cita?.googleCalendarOrigin === true;

  // =========================
  // SUGERENCIAS
  // =========================

  const sugerencias =
    pacientes
      .filter(p =>
        `${p.nombre || ""} ${p.apellidos || ""}`
          .toLowerCase()
          .includes(
            busqueda.toLowerCase()
          )
      )
      .slice(0, 5);

  // =========================
  // GUARDAR
  // =========================

  const eliminarBloqueo = async () => {
    if (
      !clinicId ||
      cita?.tipo !== "bloqueoAgenda" ||
      !cita?.id
    ) {
      return;
    }

    try {
      setEliminandoBloqueo(true);

      await deleteDoc(
        doc(
          db,
          "clinics",
          clinicId,
          "bloqueosAgenda",
          cita.id
        )
      );

      setShowDeleteBlockConfirm(false);
      onClose();
    } catch (error) {
      console.error("Error eliminando bloqueo:", error);

      setShowDeleteBlockConfirm(false);

      // El error se registra en consola; no se usa
      // una alerta nativa del navegador.
    } finally {
      setEliminandoBloqueo(false);
    }
  };

  const confirmarGuardar = () => {
    setShowConfirm(true);
  };

  const guardar = async (
      confirmarFechaAnterior = false,
      cerrarAlGuardar = true
  ) => {
    if (!clinicId) {
      return alert(
        "Clínica no válida"
      );
    }

    if (modoFormulario === "bloqueo") {
      const motivo = bloqueo.motivo.trim();

      if (!motivo) {
        return alert("Escribe el motivo del bloqueo.");
      }

      if (
        !bloqueo.fecha ||
        !bloqueo.horaInicio ||
        !bloqueo.horaFin
      ) {
        return alert("Completa la fecha y el horario.");
      }

      const minutosInicio =
        Number(bloqueo.horaInicio.split(":")[0]) * 60 +
        Number(bloqueo.horaInicio.split(":")[1]);

      const minutosFin =
        Number(bloqueo.horaFin.split(":")[0]) * 60 +
        Number(bloqueo.horaFin.split(":")[1]);

      if (minutosFin <= minutosInicio) {
        return alert(
          "La hora de término debe ser posterior a la hora de inicio."
        );
      }

      if (
        bloqueo.alcance === "doctor" &&
        !bloqueo.doctorId
      ) {
        return alert("Selecciona un doctor.");
      }

      try {
        setGuardandoBloqueo(true);

        const datosBloqueo = {
          motivo,
          descripcion: bloqueo.descripcion.trim(),
          fecha: bloqueo.fecha,
          horaInicio: bloqueo.horaInicio,
          horaFin: bloqueo.horaFin,
          timeZone: deviceTimeZone,
          scheduledAt: buildScheduledAt(
            bloqueo.fecha,
            bloqueo.horaInicio,
            deviceTimeZone
          ),
          scheduledEndAt: buildScheduledAt(
            bloqueo.fecha,
            bloqueo.horaFin,
            deviceTimeZone
          ),
          doctorId: bloqueo.doctorId || null,
          doctorNombre: bloqueo.doctorNombre || "",
          alcance: bloqueo.alcance,
          tipo: "bloqueoAgenda",
          actualizadoEn: serverTimestamp()
        };

        if (cita?.tipo === "bloqueoAgenda") {
          await updateDoc(
            doc(
              db,
              "clinics",
              clinicId,
              "bloqueosAgenda",
              cita.id
            ),
            datosBloqueo
          );
        } else {
          await addDoc(
            collection(
              db,
              "clinics",
              clinicId,
              "bloqueosAgenda"
            ),
            {
              ...datosBloqueo,
              creadoPor: auth.currentUser?.uid || null,
              creadoEn: serverTimestamp()
            }
          );
        }

        onClose();
      } catch (error) {
        console.error("Error guardando bloqueo:", error);
        alert("No se pudo guardar el bloqueo.");
      } finally {
        setGuardandoBloqueo(false);
      }

      return;
    }

    if (!pacienteSeleccionado) {
      return alert(
        "Selecciona paciente"
      );
    }

    if (
      !form.fecha ||
      !form.hora
    ) {
      return alert(
        "Fecha y hora obligatorias"
      );
    }

    const duracionNueva = obtenerDuracionMinutos(
      form.duracion ||
      clinicData?.defaultAppointmentDuration
    );

    const bloqueosEnConflicto =
      obtenerBloqueosEnConflicto(
        form.fecha,
        form.hora,
        duracionNueva
      );

    if (bloqueosEnConflicto.length > 0) {
      alert(
        "No se puede agendar esta cita porque el horario " +
        "está bloqueado. Selecciona otro horario."
      );

      return;
    }

    if (guardandoCitaRef.current) return;
    if (!agendaLista) {window.alert("Espera a que termine de actualizarse la agenda antes de guardar.");return;}
    guardandoCitaRef.current = true;
    setGuardandoCita(true);
    try {
      const presupuesto =
        Number(
          form.presupuesto || 0
        );

      // =========================
      // ALERTA POR FECHA ANTERIOR
      // =========================

      const hoy = new Date();

      const hoyLocal =
        hoy.getFullYear() +
        "-" +
        String(
          hoy.getMonth() + 1
        ).padStart(2, "0") +
        "-" +
        String(
          hoy.getDate()
        ).padStart(2, "0");

      if (
        form.fecha < hoyLocal &&
        !confirmarFechaAnterior
      ) {
        setShowPastDateWarning(true);
        return;
      }

      // =====================
      // EDITAR
      // =====================

      if (cita) {
        const estadoAnterior =
          cita.estado;

        const fechaCambio =
          cita.fecha !== form.fecha;

        await updateDoc(
          doc(
            db,
            "clinics",
            clinicId,
            "citas",
            cita.id
          ),
          {
            ...form,

            timeZone: deviceTimeZone,

            scheduledAt: buildScheduledAt(
              form.fecha,
              form.hora,
              deviceTimeZone
            ),

            presupuesto,

            pacienteId:
              pacienteSeleccionado.id,

            pacienteNombre:
              `${pacienteSeleccionado.nombre} ${pacienteSeleccionado.apellidos}`,

            recordatorioEnviado:
              fechaCambio
                ? false
                : Boolean(
                    cita.recordatorioEnviado
                  ),

            recordatorioEnviadoAt:
              fechaCambio
                ? null
                : (
                    cita.recordatorioEnviadoAt ||
                    null
                  )
          }
        );

        // =====================================
        // SINCRONIZAR CUENTA POR COBRAR
        // FIRESTORE = FUENTE DE VERDAD
        // =====================================

        if (
          pacienteSeleccionado.id
        ) {
          const cuentasRef =
            collection(
              db,
              "clinics",
              clinicId,
              "pacientes",
              pacienteSeleccionado.id,
              "cuentasPorCobrar"
            );

          let cuentaId =
            cita.cuentaPorCobrarId ||
            null;

          // =====================================
          // SI LA CITA NO TIENE EL ID,
          // BUSCAMOS POR citaId
          // =====================================

          if (!cuentaId) {
            const q =
              query(
                cuentasRef,
                where(
                  "citaId",
                  "==",
                  cita.id
                )
              );

            const snapshot =
              await getDocs(q);

            if (
              !snapshot.empty
            ) {
              cuentaId =
                snapshot.docs[0].id;
            }
          }

          // =====================================
          // SI EXISTE CUENTA
          // =====================================

          if (cuentaId) {
            const cuentaSnap =
              await getDoc(
                doc(
                  cuentasRef,
                  cuentaId
                )
              );

            if (
              !cuentaSnap.exists()
            ) {
              throw new Error(
                "La cuenta por cobrar no existe."
              );
            }

            const cuentaData =
              cuentaSnap.data();

            // =====================================
            // EL PAGADO VIENE DE FIRESTORE
            // NO DE cita.pagado
            // =====================================

            const pagadoReal =
              Number(
                cuentaData.pagado || 0
              );

            // =====================================
            // PRESUPUESTO = $0
            // =====================================

            if (
              presupuesto <= 0
            ) {
              if (
                pagadoReal > 0
              ) {
                throw new Error(
                  "No puedes eliminar una cuenta por cobrar que ya tiene pagos registrados."
                );
              }

              await deleteDoc(
                doc(
                  cuentasRef,
                  cuentaId
                )
              );

              await updateDoc(
                doc(
                  db,
                  "clinics",
                  clinicId,
                  "citas",
                  cita.id
                ),
                {
                  cuentaPorCobrarId:
                    null,

                  pagado:
                    0,

                  saldo:
                    0
                }
              );
            }

            // =====================================
            // ACTUALIZAR CUENTA
            // =====================================

            else {
              const nuevoSaldo =
                Math.max(
                  0,
                  presupuesto -
                  pagadoReal
                );

              await updateDoc(
                doc(
                  cuentasRef,
                  cuentaId
                ),
                {
                  total:
                    presupuesto,

                  pagado:
                    pagadoReal,

                  saldo:
                    nuevoSaldo,

                  estado:
                    nuevoSaldo > 0
                      ? "Pendiente"
                      : "Pagada"
                }
              );

              // =====================================
              // LA CITA SOLO REFLEJA FIRESTORE
              // =====================================

              await updateDoc(
                doc(
                  db,
                  "clinics",
                  clinicId,
                  "citas",
                  cita.id
                ),
                {
                  pagado:
                    pagadoReal,

                  saldo:
                    nuevoSaldo
                }
              );
            }
          }

          // =====================================
          // NO EXISTE CUENTA
          // PERO AHORA HAY PRESUPUESTO
          // =====================================

          else if (
            presupuesto > 0
          ) {
            const cuentaRef =
              await addDoc(
                cuentasRef,
                {
                  clinicId,

                  tipo:
                    "cita",

                  citaId:
                    cita.id,

                  descripcion:
                    form.motivo?.trim() ||
                    "Consulta dental",

                  total:
                    presupuesto,

                  pagado:
                    0,

                  saldo:
                    presupuesto,

                  estado:
                    "Pendiente",

                  createdAt:
                    serverTimestamp()
                }
              );

            await updateDoc(
              doc(
                db,
                "clinics",
                clinicId,
                "citas",
                cita.id
              ),
              {
                cuentaPorCobrarId:
                  cuentaRef.id,

                pagado:
                  0,

                saldo:
                  presupuesto
              }
            );
          }
        }

        if (abrirEvolucionAlGuardarRef.current) {
          abrirEvolucionAlGuardarRef.current = false;
          setMostrarEvolucionEnCita(true);
        } else if (cerrarAlGuardar) {
          onClose();
        }

        return true;
      }

      // =====================
      // NUEVA CITA
      // =====================

      else {
        const resultado = await createAppointment({
          clinicId,

          clinicData,

          paciente:
            pacienteSeleccionado,

          form,

          enviarNotificacionWhatsApp
        });

        onClose();

        if (resultado?.whatsappResult && !resultado.whatsappResult.success) {
          window.alert(
            `La cita se creó correctamente, pero no se pudo enviar el WhatsApp: ${resultado.whatsappResult.error || "el servicio no confirmó el envío."}`
          );
        }
      }
    } catch (err) {
      abrirEvolucionAlGuardarRef.current = false;
      console.error(
        "ERROR COMPLETO:",
        err
      );

      alert(
        err.message
      );
    } finally {
      guardandoCitaRef.current = false;
      setGuardandoCita(false);
    }
  };

  // =========================
  // ELIMINAR
  // =========================

  const eliminar = async () => {
    if (!clinicId) {
      return;
    }

    if (!cita) {
      return;
    }

    try {
      // =====================================
      // ELIMINAR CUENTA POR COBRAR ASOCIADA
      // =====================================

      if (cita.pacienteId) {
        const cuentasRef =
          collection(
            db,
            "clinics",
            clinicId,
            "pacientes",
            cita.pacienteId,
            "cuentasPorCobrar"
          );

        let cuentaId =
          cita.cuentaPorCobrarId ||
          null;

        // =====================================
        // SI LA CITA NO TIENE EL ID,
        // BUSCAMOS LA CUENTA POR citaId
        // =====================================

        if (!cuentaId) {
          const q =
            query(
              cuentasRef,
              where(
                "citaId",
                "==",
                cita.id
              )
            );

          const snapshot =
            await getDocs(q);

          if (
            !snapshot.empty
          ) {
            cuentaId =
              snapshot.docs[0].id;
          }
        }

        // =====================================
        // ELIMINAR CUENTA
        // =====================================

        if (cuentaId) {
          const cuentaSnap =
            await getDoc(
              doc(
                cuentasRef,
                cuentaId
              )
            );

          if (
            cuentaSnap.exists()
          ) {
            const cuentaData =
              cuentaSnap.data();

            const pagadoReal =
              Number(
                cuentaData.pagado || 0
              );

            if (
              pagadoReal > 0
            ) {
              throw new Error(
                "No puedes eliminar esta cita porque la cuenta por cobrar ya tiene pagos registrados."
              );
            }

            await deleteDoc(
              doc(
                cuentasRef,
                cuentaId
              )
            );
          }
        }
      }

      // =====================================
      // ELIMINAR CITA
      // =====================================

      await deleteDoc(
        doc(
          db,
          "clinics",
          clinicId,
          "citas",
          cita.id
        )
      );

      // =====================================
      // REGISTRAR ACCIÓN
      // =====================================

      await logAction({
        clinicId,

        action:
          "ELIMINAR_CITA",

        module:
          "citas",

        targetName:
          cita.pacienteNombre
      });

      onClose();
    } catch (err) {
      console.error(
        "Error eliminando cita y cuenta por cobrar:",
        err
      );

      alert(
        err.message ||
        "Error al eliminar cita"
      );
    }
  };

  // =========================
  // ESTILOS
  // =========================

  const container = {
    position: "fixed",
    inset: 0,
    width: "100vw",
    height: "100dvh",
    background:
      "rgba(15,23,42,.52)",
    display: "flex",
    justifyContent: "center",
    alignItems:
      isMobile
        ? "stretch"
        : "center",
    zIndex: 2147483647,
    padding:
      isMobile
        ? 0
        : 20,
    boxSizing: "border-box",
    isolation: "isolate"
  };

  const modal = {
    background: "#fff",

    width:
      isMobile
        ? "100%"
        : 860,

    maxWidth:
      isMobile
        ? "100%"
        : "95vw",

    height:
      isMobile
        ? "100dvh"
        : "auto",

    maxHeight:
      isMobile
        ? "100dvh"
        : "92vh",

    overflowY: "auto",

    overflowX: "hidden",

    WebkitOverflowScrolling:
      "touch",

    borderRadius:
      isMobile
        ? 0
        : 28,

    padding:
      isMobile
        ? "calc(10px + env(safe-area-inset-top)) 18px calc(110px + env(safe-area-inset-bottom))"
        : 24,

    display: "flex",

    flexDirection:
      "column",

    gap:
      isMobile
        ? 14
        : 16,

    boxShadow:
      isMobile
        ? "none"
        : "0 24px 80px rgba(15,23,42,.18)",

    fontFamily:
      "Inter, system-ui",

    boxSizing:
      "border-box",

    position:
      "relative"
  };

  const row = (
    label,
    input
  ) => (
    <div
      style={{
        display: "grid",

        gridTemplateColumns:
          "120px 1fr",

        alignItems:
          "center",

        gap: 6,

        minWidth: 0
      }}
    >
      <div
        style={{
          fontWeight: 600,
          fontSize: 13,
          color: "#374151"
        }}
      >
        {label}
      </div>

      <div
        style={{
          width: "100%",
          minWidth: 0,
          maxWidth: "100%"
        }}
      >
        {input}
      </div>
    </div>
  );

  const inputStyle = {
    width: "100%",

    maxWidth: "100%",

    minWidth: 0,

    display: "block",

    height:
      isMobile
        ? 48
        : 48,

    padding:
      isMobile
        ? "0 10px"
        : "0 16px",

    borderRadius: 15,

    border:
      "1px solid #dbe2ea",

    background:
      "#ffffff",

    fontSize:
      isMobile
        ? 16
        : 14,

    color:
      "#0f172a",

    outline:
      "none",

    transition:
      "all .2s ease",

    boxSizing:
      "border-box",

    WebkitAppearance:
      "none",

    appearance:
      "none"
  };

  const textAreaStyle = {
    ...inputStyle,

    height:
      isMobile
        ? 116
        : 110,

    padding:
      "14px 15px",

    resize:
      "vertical",

    fontFamily:
      "inherit",

    lineHeight:
      1.5
  };

  const buttonPrimary = {
    padding:
      "8px 14px",

    borderRadius:
      10,

    border:
      "none",

    background:
      "#2563eb",

    color:
      "#fff",

    cursor:
      "pointer"
  };

  const buttonDanger = {
    padding:
      "8px 14px",

    borderRadius:
      10,

    border:
      "none",

    background:
      "#dc2626",

    color:
      "#fff",

    cursor:
      "pointer"
  };

  const buttonSecondary = {
    padding:
      "8px 14px",

    borderRadius:
      10,

    border:
      "none",

    background:
      "#e5e7eb",

    cursor:
      "pointer"
  };

  // =========================
  // RENDER
  // =========================

  return createPortal(
    <div className="vd-appointment-backdrop" style={container}>

      <div className="vd-appointment-modal" style={modal}>
        
        {/* =========================
            ENCABEZADO
        ========================= */}

        <div className="vd-appointment-modal-header"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            marginBottom: 2,
            background: "#fff",
            paddingTop: isMobile ? 2 : 0,
            paddingBottom: 4
          }}
        >
          <div
            style={{
              width: isMobile ? 46 : 50,
              height: isMobile ? 46 : 50,
              borderRadius: 15,
              background: "#dbeafe",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexShrink: 0
            }}
          >
            {modoFormulario === "bloqueo" ? (
              <CalendarDays size={24} color="#2563eb" />
            ) : cita ? (
              <PencilLine size={24} color="#2563eb" />
            ) : (
              <CalendarPlus size={24} color="#2563eb" />
            )}
          </div>

          <div>
            <div
              style={{
                fontSize: isMobile ? 20 : 22,
                fontWeight: 750,
                color: "#0f172a"
              }}
            >
              {cita
                ? "Editar cita"
                : modoFormulario === "bloqueo"
                  ? "Bloquear agenda"
                  : "Nueva cita"}
            </div>

            <div
              style={{
                marginTop: 2,
                color: "#64748b",
                fontSize: 14,
                lineHeight: 1.4
              }}
            >
              {modoFormulario === "bloqueo" && !cita
                ? "Reserva un horario sin asociarlo a un paciente."
                : isMobile
                  ? "Completa los datos de la cita"
                  : "Agenda una cita y administra toda la información del paciente."}
            </div>
          </div>

          <button
            type="button"
            onClick={onClose}
            aria-label="Cerrar"
            style={{
              marginLeft: "auto",
              width: 42,
              height: 42,
              borderRadius: 14,
              border: "1px solid #e2e8f0",
              background: "#fff",
              color: "#64748b",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              cursor: "pointer"
            }}
          >
            <X size={20} />
          </button>
        </div>

        {/* =========================
            TIPO DE EVENTO
        ========================= */}

        {!cita && (
          <div className="vd-appointment-mode-switch"
            style={{
              display: "flex",
              gap: 8,
              padding: 5,
              margin: "18px 0",
              background: "#f1f5f9",
              borderRadius: 12
            }}
          >
            {[
              { id: "cita", label: "Cita con paciente" },
              { id: "bloqueo", label: "Bloqueo de agenda" }
            ].map(opcion => (
              <button
                key={opcion.id}
                type="button"
                onClick={() => setModoFormulario(opcion.id)}
                style={{
                  flex: 1,
                  padding: "12px 8px",
                  border: "none",
                  borderRadius: 9,
                  cursor: "pointer",
                  fontWeight: 700,
                  background:
                    modoFormulario === opcion.id
                      ? "#fff"
                      : "transparent",
                  color:
                    modoFormulario === opcion.id
                      ? "#2563eb"
                      : "#64748b",
                  boxShadow:
                    modoFormulario === opcion.id
                      ? "0 1px 4px rgba(0,0,0,.10)"
                      : "none"
                }}
              >
                {opcion.label}
              </button>
            ))}
          </div>
        )}

          {modoFormulario === "bloqueo" ? (
          <form className="vd-appointment-block-form"
            onSubmit={(e) => {
              e.preventDefault();
              guardar();
            }}
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 16,
              padding: "8px 2px 18px"
            }}
          >
            <div style={{
              padding: 16,
              border: "1px solid #bfdbfe",
              borderRadius: 14,
              background: "#eff6ff"
            }}>
              <div style={{ fontSize: 16, fontWeight: 750, color: "#1e40af" }}>
                Bloqueo de agenda
              </div>
              <div style={{ marginTop: 5, fontSize: 13, color: "#475569" }}>
                Reserva un horario sin crear una cita ni asociarlo a un paciente.
              </div>
            </div>

            <label style={{ display: "flex", flexDirection: "column", gap: 7, fontSize: 13, fontWeight: 700, color: "#334155" }}>
              Motivo del bloqueo *
              <input
                required
                value={bloqueo.motivo}
                onChange={e => setBloqueo(v => ({ ...v, motivo: e.target.value }))}
                placeholder="Ej. Comida, reunión, mantenimiento"
                style={inputStyle}
              />
            </label>

            <div style={{
              display: "grid",
              gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
              gap: 14
            }}>
              <label style={{ display: "flex", flexDirection: "column", gap: 7, fontSize: 13, fontWeight: 700, color: "#334155" }}>
                Fecha *
                <input
                  required
                  aria-label="Fecha de la cita" type="date"
                  value={bloqueo.fecha}
                  onChange={e => setBloqueo(v => ({ ...v, fecha: e.target.value }))}
                  style={inputStyle}
                />
              </label>

              <label style={{ display: "flex", flexDirection: "column", gap: 7, fontSize: 13, fontWeight: 700, color: "#334155" }}>
                Alcance *
                <select
                  value={bloqueo.alcance}
                  onChange={e => setBloqueo(v => ({ ...v, alcance: e.target.value }))}
                  style={inputStyle}
                >
                  <option value="doctor">Un doctor</option>
                  <option value="todos">Toda la agenda</option>
                </select>
              </label>

              <label style={{ display: "flex", flexDirection: "column", gap: 7, fontSize: 13, fontWeight: 700, color: "#334155" }}>
                Hora de inicio *
                <input
                  required
                  type="time"
                  value={bloqueo.horaInicio}
                  onChange={e => setBloqueo(v => ({ ...v, horaInicio: e.target.value }))}
                  style={inputStyle}
                />
              </label>

              <label style={{ display: "flex", flexDirection: "column", gap: 7, fontSize: 13, fontWeight: 700, color: "#334155" }}>
                Hora de término *
                <input
                  required
                  type="time"
                  value={bloqueo.horaFin}
                  onChange={e => setBloqueo(v => ({ ...v, horaFin: e.target.value }))}
                  style={inputStyle}
                />
              </label>
            </div>

            {bloqueo.alcance === "doctor" && (
              <label style={{ display: "flex", flexDirection: "column", gap: 7, fontSize: 13, fontWeight: 700, color: "#334155" }}>
                Doctor *
                <select
                  required
                  value={bloqueo.doctorId}
                  onChange={e => {
                    const doctor = doctores.find(d => d.id === e.target.value);
                    setBloqueo(v => ({
                      ...v,
                      doctorId: e.target.value,
                      doctorNombre: doctor
                        ? `${doctor.nombreAgenda || doctor.nombre || doctor.displayName || doctor.email || ""} ${doctor.apellidos || ""}`.trim()
                        : ""
                    }));
                  }}
                  style={inputStyle}
                >
                  <option value="">Selecciona un doctor</option>
                  {doctores.map(d => (
                    <option key={d.id} value={d.id}>
                      {`${d.nombreAgenda || d.nombre || d.displayName || d.email || "Doctor"} ${d.apellidos || ""}`.trim()}
                    </option>
                  ))}
                </select>
              </label>
            )}

            <label style={{ display: "flex", flexDirection: "column", gap: 7, fontSize: 13, fontWeight: 700, color: "#334155" }}>
              Descripción
              <textarea
                rows={3}
                value={bloqueo.descripcion}
                onChange={e => setBloqueo(v => ({ ...v, descripcion: e.target.value }))}
                placeholder="Información adicional (opcional)"
                style={textAreaStyle}
              />
            </label>

            <div style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 10,
              paddingTop: 14,
              borderTop: "1px solid #e2e8f0"
            }}>

              {cita?.tipo === "bloqueoAgenda" && (
                <button
                  type="button"
                  onClick={() => setShowDeleteBlockConfirm(true)}
                  disabled={guardandoBloqueo || eliminandoBloqueo}
                  style={{
                    marginRight: "auto",
                    padding: "12px 18px",
                    border: "1px solid #fecaca",
                    borderRadius: 10,
                    background: "#fff",
                    color: "#dc2626",
                    fontWeight: 700,
                    cursor: "pointer"
                  }}
                >
                  Eliminar bloqueo
                </button>
              )}

              <button
                type="button"
                onClick={onClose}
                disabled={guardandoBloqueo}
                style={{
                  padding: "12px 18px",
                  border: "1px solid #cbd5e1",
                  borderRadius: 10,
                  background: "#fff",
                  color: "#475569",
                  fontWeight: 700,
                  cursor: "pointer"
                }}
              >
                Cancelar
              </button>

              <button
                type="submit"
                disabled={guardandoBloqueo}
                style={{
                  padding: "12px 20px",
                  border: "none",
                  borderRadius: 10,
                  background: guardandoBloqueo ? "#94a3b8" : "#2563eb",
                  color: "#fff",
                  fontWeight: 700,
                  cursor: guardandoBloqueo ? "wait" : "pointer"
                }}
              >
                {guardandoBloqueo ? "Guardando..." : "Guardar bloqueo"}
              </button>
            </div>
          </form>
        ) : (
          <>
          </>
        )}

        <div className="vd-appointment-form-body"
          style={{
            display: modoFormulario === "bloqueo"
              ? "none"
              : "contents"
          }}
        >
        
        {/* =========================
            PACIENTE SELECCIONADO
        ========================= */}

        {
          pacienteSeleccionado &&
          paciente && (

            <div
              style={{
                display:
                  "flex",

                alignItems:
                  "center",

                gap:
                  12,

                padding:
                  isMobile
                    ? "12px 14px"
                    : "12px 16px",

                background:
                  "#f8fbff",

                border:
                  "1px solid #dbeafe",

                borderRadius:
                  16
              }}
            >

              <div
                style={{
                  width:
                    38,

                  height:
                    38,

                  borderRadius:
                    12,

                  background:
                    "#dbeafe",

                  color:
                    "#2563eb",

                  display:
                    "flex",

                  alignItems:
                    "center",

                  justifyContent:
                    "center",

                  flexShrink:
                    0
                }}
              >

                <User size={20} />

              </div>

              <div
                style={{
                  minWidth:
                    0
                }}
              >

                <div
                  style={{
                    fontSize:
                      13,

                    color:
                      "#64748b",

                    marginBottom:
                      2
                  }}
                >

                  Paciente

                </div>

                <div
                  style={{
                    fontSize:
                      15,

                    fontWeight:
                      700,

                    color:
                      "#0f172a",

                    overflow:
                      "hidden",

                    textOverflow:
                      "ellipsis",

                    whiteSpace:
                      "nowrap"
                  }}
                >

                  {
                    pacienteSeleccionado.nombre
                  }{" "}
                  {
                    pacienteSeleccionado.apellidos
                  }

                </div>

              </div>

            </div>

          )
        }

        {/* =========================
            GOOGLE CALENDAR
        ========================= */}

        {
          importedFromGoogle && (

            <div
              style={{
                background:
                  "#fff7ed",

                border:
                  "1px solid #fdba74",

                color:
                  "#9a3412",

                padding:
                  12,

                borderRadius:
                  10,

                marginBottom:
                  10,

                fontSize:
                  13,

                lineHeight:
                  1.4
              }}
            >

              <strong>
                Google Calendar
              </strong>

              <div
                style={{
                  marginTop:
                    4
                }}
              >

                Esta cita fue importada desde Google Calendar.

                {
                  !pacienteSeleccionado && (
                    <>
                      <br />

                      Aún no está vinculada a un paciente de VexaDent.

                      <div
                        style={{
                          marginTop:
                            12
                        }}
                      >

                        <button
                          type="button"

                          onClick={() => {

                            const texto =
                              cita?.googleEventTitle ||
                              cita?.motivo ||
                              "";

                            setBusqueda(
                              texto
                            );

                            const match =
                              findBestPatientMatch(
                                texto,
                                pacientes
                              );

                            if (
                              match &&
                              match.score >= 2
                            ) {
                              setPacienteSeleccionado(
                                match.patient
                              );

                              setBusqueda(
                                `${match.patient.nombre} ${match.patient.apellidos}`
                              );

                              setMostrarLista(
                                false
                              );
                            } else {
                              setMostrarLista(
                                true
                              );
                            }

                            setTimeout(() => {
                              document
                                .getElementById(
                                  "buscarPaciente"
                                )
                                ?.focus();
                            }, 50);

                          }}

                          style={{
                            background:
                              "#2563eb",

                            color:
                              "#fff",

                            border:
                              "none",

                            borderRadius:
                              8,

                            padding:
                              "8px 14px",

                            cursor:
                              "pointer",

                            fontWeight:
                              "bold"
                          }}
                        >

                          Vincular paciente

                        </button>

                      </div>
                    </>
                  )
                }

              </div>

            </div>

          )
        }

        {/* =========================
            PACIENTE / DOCTOR
        ========================= */}

        <div
          style={{
            display:
              "grid",

            gridTemplateColumns:
              isMobile
                ? "1fr"
                : "repeat(2,minmax(0,1fr))",

            gap:
              isMobile
                ? 14
                : 20,

            marginBottom:
              isMobile
                ? 4
                : 14
          }}
        >

          {/* PACIENTE */}

          {
            !paciente && (

              <div>

                <div
                  style={{
                    fontWeight:
                      600,

                    color:
                      "#334155",

                    marginBottom:
                      6,

                    fontSize:
                      13
                  }}
                >

                  Paciente

                </div>

                <div
                  style={{
                    position:
                      "relative"
                  }}
                >

                  <input
                    id="buscarPaciente"

                    style={
                      inputStyle
                    }

                    placeholder=
                      "Buscar paciente..."

                    value={
                      busqueda
                    }

                    onChange={e => {

                      setBusqueda(
                        e.target.value
                      );

                      setMostrarLista(
                        true
                      );

                    }}
                  />

                  {
                    mostrarLista && (

                      <div
                        style={{
                          position:
                            "absolute",

                          top:
                            "calc(100% + 6px)",

                          left:
                            0,

                          right:
                            0,

                          background:
                            "#fff",

                          border:
                            "1px solid #e2e8f0",

                          borderRadius:
                            16,

                          boxShadow:
                            "0 10px 30px rgba(15,23,42,.08)",

                          maxHeight:
                            220,

                          overflowY:
                            "auto",

                          zIndex:
                            100
                        }}
                      >

                        {
                          sugerencias.length > 0
                            ? (

                              sugerencias.map(
                                p => (

                                  <div
                                    key={
                                      p.id
                                    }

                                    style={{
                                      padding:
                                        "12px 16px",

                                      cursor:
                                        "pointer",

                                      borderBottom:
                                        "1px solid #f1f5f9"
                                    }}

                                    onMouseDown={() => {

                                      setPacienteSeleccionado(
                                        p
                                      );

                                      setBusqueda(
                                        `${p.nombre} ${p.apellidos}`
                                      );

                                      setMostrarLista(
                                        false
                                      );

                                    }}
                                  >

                                    <div
                                      style={{
                                        fontWeight:
                                          600,

                                        color:
                                          "#0f172a"
                                      }}
                                    >

                                      {
                                        p.nombre
                                      }{" "}
                                      {
                                        p.apellidos
                                      }

                                    </div>

                                  </div>

                                )
                              )

                            )
                            : (

                              <div
                                style={{
                                  padding:
                                    16
                                }}
                              >

                                <div
                                  style={{
                                    marginBottom:
                                      12,

                                    color:
                                      "#64748b"
                                  }}
                                >

                                  No se encontró ningún paciente.

                                </div>

                                <button
                                  style={
                                    buttonPrimary
                                  }

                                  onMouseDown={e => {

                                    e.preventDefault();

                                    setShowPacienteForm(
                                      true
                                    );

                                  }}
                                >

                                  + Agregar paciente

                                </button>

                              </div>

                            )
                        }

                      </div>

                    )
                  }

                </div>

              </div>

            )
          }

          {/* DOCTOR */}

          <div>

            <div
              style={{
                fontWeight:
                  600,

                color:
                  "#334155",

                marginBottom:
                  6,

                fontSize:
                  13
              }}
            >

              Doctor

            </div>

            <select
              aria-label="Doctor de la cita"
              style={
                inputStyle
              }

              value={
                form.doctorId
              }

              onChange={e => {

                const doctor =
                  doctores.find(
                    d =>
                      d.id ===
                      e.target.value
                  );

                setForm({
                  ...form,

                  doctorId:
                    doctor?.id ||
                    "",

                  doctorNombre:
                    doctor?.nombreAgenda || doctor?.nombre ||
                    "",

                  doctorColor:
                    doctor?.color ||
                    "#3b82f6"
                });

              }}
            >

              <option value="">
                Seleccionar doctor
              </option>

              {
                doctores.map(
                  d => (

                    <option
                      key={
                        d.id
                      }

                      value={
                        d.id
                      }
                    >

                      {
                        d.nombreAgenda || d.nombre
                      }

                    </option>

                  )
                )
              }

            </select>

          </div>

        </div>

        {/* =========================
            FECHA / HORA / ESTADO / DURACIÓN
        ========================= */}

        <div
          style={{
            display:
              "grid",

            gridTemplateColumns:
              isMobile
                ? "1fr"
                : "repeat(2,minmax(0,1fr))",

            gap:
              isMobile
                ? 14
                : 20,

            marginBottom:
              isMobile
                ? 4
                : 14
          }}
        >

          {/* FECHA */}

          <div
            style={{
              minWidth:
                0
            }}
          >

            <div
              style={{
                fontWeight:
                  600,

                color:
                  "#334155",

                marginBottom:
                  6,

                fontSize:
                  13
              }}
            >

              Fecha

            </div>

            <input
              aria-label="Fecha de la cita" type="date"

              style={{
                ...inputStyle,
                width: "100%",
                minWidth: 0,
                maxWidth: "100%",
                flex: "1 1 0"
              }}

              value={
                form.fecha
              }

              onChange={e => {
                setConflictoAceptadoKey("");

                setForm({
                  ...form,
                  fecha: e.target.value
                });
              }}
            />

          </div>

          
          {/* HORA */}

          <div style={{ minWidth: 0 }}>
            <div
              style={{
                fontWeight: 600,
                color: "#334155",
                marginBottom: 6,
                fontSize: 13
              }}
            >
              Hora
            </div>

            <button
              type="button"
              onClick={() => {
                const partes = (form.hora || "").split(":");
                const hora24 = Number(partes[0] || 12);
                const minutos = partes[1] || "00";

                setHoraSelector(
                  String(hora24 % 12 || 12)
                );
                setMinutoSelector(minutos);
                setPeriodoSelector(hora24 >= 12 ? "PM" : "AM");
                setMostrarSelectorHora(true);
              }}
              style={{
                ...inputStyle,
                width: "100%",
                minHeight: 42,
                textAlign: "left",
                background: "#fff",
                cursor: "pointer"
              }}
            >
              {form.hora
                ? `${Number(form.hora.split(":")[0]) % 12 || 12}:${form.hora.split(":")[1]} ${Number(form.hora.split(":")[0]) >= 12 ? "PM" : "AM"}`
                : "Seleccionar hora"}
            </button>
          </div>

          {/* ESTADO */}

          <div>

            <div
              style={{
                fontWeight:
                  600,

                color:
                  "#334155",

                marginBottom:
                  6,

                fontSize:
                  13
              }}
            >

              Estado

            </div>

            <select
              style={
                inputStyle
              }

              value={
                form.estado
              }

              onChange={e =>
                setForm({
                  ...form,

                  estado:
                    e.target.value
                })
              }
            >

              <option value="activa">
                Activa
              </option>

              <option value="confirmada">
                Confirmada
              </option>

              <option value="pagada">
                Pagada
              </option>

              <option value="cancelada">
                Cancelada
              </option>

            </select>

          </div>

          {/* DURACIÓN */}

          <div>

            <div
              style={{
                fontWeight:
                  600,

                color:
                  "#334155",

                marginBottom:
                  6,

                fontSize:
                  13
              }}
            >

              Duración

            </div>

            <select
              style={
                inputStyle
              }

              value={
                form.duracion
              }

              onChange={e =>
                setForm({
                  ...form,

                  duracion:
                    e.target.value
                })
              }
            >

              <option value="15">
                15 minutos
              </option>

              <option value="30">
                30 minutos
              </option>

              <option value="45">
                45 minutos
              </option>

              <option value="60">
                60 minutos
              </option>

              <option value="90">
                90 minutos
              </option>

              <option value="120">
                120 minutos
              </option>

            </select>

          </div>

        </div>

        {/* =========================
            MOTIVO / PRESUPUESTO
        ========================= */}

        <div
          style={{
            display:
              "grid",

            gridTemplateColumns:
              isMobile
                ? "1fr"
                : "2fr 1fr",

            gap:
              isMobile
                ? 14
                : 20,

            marginBottom:
              isMobile
                ? 4
                : 14
          }}
        >

          {/* MOTIVO */}

          <div>

            <div
              style={{
                fontWeight:
                  600,

                color:
                  "#334155",

                marginBottom:
                  6,

                fontSize:
                  13
              }}
            >

              Motivo de la cita

            </div>

            <input
              style={
                inputStyle
              }

              placeholder=
                "Ej. Extracción de tercer molar"

              value={
                form.motivo
              }

              onChange={e =>
                setForm({
                  ...form,

                  motivo:
                    e.target.value
                })
              }
            />

          </div>

          {/* PRESUPUESTO */}

          <div>

            <div
              style={{
                fontWeight:
                  600,

                color:
                  "#334155",

                marginBottom:
                  6,

                fontSize:
                  13
              }}
            >

              Presupuesto

            </div>

            <input
              style={
                inputStyle
              }

              placeholder="$0.00"

              value={
                form.presupuesto
              }

              onChange={e =>
                setForm({
                  ...form,

                  presupuesto:
                    e.target.value
                })
              }
            />

          </div>

        </div>

        {/* =========================
            TRATAMIENTO
        ========================= */}

        <div
          style={{
            marginBottom:
              isMobile
                ? 4
                : 14
          }}
        >

          <div
            style={{
              fontWeight:
                600,

              color:
                "#334155",

              marginBottom:
                6,

              fontSize:
                13
            }}
          >

            Tratamiento realizado

          </div>

          <input
            style={
              inputStyle
            }

            placeholder=
              "Describe el tratamiento realizado"

            value={
              form.tratamiento ||
              ""
            }

            onChange={e =>
              setForm({
                ...form,

                tratamiento:
                  e.target.value
              })
            }
          />

        </div>

        {/* =========================
            EVOLUCIÓN
        ========================= */}

        <div
          style={{
            marginBottom:
              isMobile
                ? 4
                : 14
          }}
        >

          <div
            style={{
              fontWeight:
                600,

              color:
                "#334155",

              marginBottom:
                6,

              fontSize:
                13
            }}
          >

            Evolución clínica

          </div>

          <textarea
            style={
              textAreaStyle
            }

            placeholder=
              "Observaciones clínicas, evolución del paciente, indicaciones..."

            value={
              form.notas
            }

            onChange={e =>
              setForm({
                ...form,

                notas:
                  e.target.value
              })
            }
          />

          {cita && (
            <div style={{ marginTop: 12 }}>
              <button
                type="button"
                onClick={async () => {
                  if (mostrarEvolucionEnCita) {
                    setMostrarEvolucionEnCita(false);
                    return;
                  }

                  abrirEvolucionAlGuardarRef.current = true;

                  const guardado = await guardar(false, false);

                  if (!guardado) {
                    abrirEvolucionAlGuardarRef.current = false;
                  }
                }}
                style={{
                  width: "100%",
                  padding: 12,
                  border: "1px solid #2563eb",
                  borderRadius: 10,
                  background: "#eff6ff",
                  color: "#1d4ed8",
                  fontWeight: 600,
                  cursor: "pointer"
                }}
              >
                {mostrarEvolucionEnCita
                  ? "Ocultar evolución y firma"
                  : "Abrir evolución clínica y firma"}
              </button>

              {mostrarEvolucionEnCita && (
                <div style={{ marginTop: 12 }}>
                  <EvolutionCard
                    cita={
                      citasExistentes.find(item => item.id === cita.id) || cita
                    }
                    clinicId={clinicId}
                    formatearFecha={fecha =>
                      fecha
                        ? new Date(`${fecha}T12:00:00`).toLocaleDateString("es-MX")
                        : ""
                    }
                  />
                </div>
              )}
            </div>
          )}

        </div>

        {/* =========================
            PRÓXIMA CITA
        ========================= */}

        <div
          style={{
            marginBottom:
              isMobile
                ? 4
                : 14
          }}
        >

          <div
            style={{
              fontWeight:
                600,

              color:
                "#334155",

              marginBottom:
                6,

              fontSize:
                13
            }}
          >

            Próxima cita / Indicaciones

          </div>

          <textarea
            style={
              textAreaStyle
            }

            placeholder=
              "Fecha sugerida, tratamiento pendiente o indicaciones para la siguiente visita"

            value={
              form.proximo
            }

            onChange={e =>
              setForm({
                ...form,

                proximo:
                  e.target.value
              })
            }
          />

        </div>

        {/* =========================
            NOTIFICACIÓN WHATSAPP
        ========================= */}

        <div className="vd-appointment-whatsapp"
          style={{
            marginTop:
              isMobile
                ? 8
                : 24,

            padding:
              isMobile
                ? 14
                : 16,

            background:
              "#f8fafc",

            border:
              "1px solid #e2e8f0",

            borderRadius:
              14
          }}
        >

          <label
            style={{
              display:
                "flex",

              alignItems:
                "center",

              gap:
                10,

              cursor:
                "pointer",

              fontWeight:
                600,

              color:
                "#334155"
            }}
          >

            <input
              type="checkbox"

              checked={
                enviarNotificacionWhatsApp
              }

              onChange={e =>
                setEnviarNotificacionWhatsApp(
                  e.target.checked
                )
              }
            />

            Enviar notificación por WhatsApp

          </label>

          <div
            style={{
              marginTop:
                6,

              marginLeft:
                26,

              fontSize:
                13,

              color:
                "#64748b",

              lineHeight:
                1.45
            }}
          >

            Envía un mensaje al paciente cuando se crea o modifica esta cita.

          </div>

        </div>

        {/* =========================
            BOTONES
        ========================= */}

        <div className="vd-appointment-footer"
          style={{
            marginTop:
              isMobile
                ? 8
                : 30,

            paddingTop:
              isMobile
                ? 14
                : 24,

            paddingBottom:
              isMobile
                ? "calc(8px + env(safe-area-inset-bottom))"
                : 0,

            borderTop:
              "1px solid #e2e8f0",

            display:
              "flex",

            background:
              "#fff",

            flexDirection:
              isMobile
                ? "column"
                : "row",

            justifyContent:
              "space-between",

            alignItems:
              isMobile
                ? "stretch"
                : "center",

            gap:
              12,

            flexWrap:
              "wrap"
          }}
        >

          {/* CANCELAR */}

          <button
            style={{
              height:
                isMobile
                  ? 50
                  : 48,

              padding:
                "0 22px",

              border:
                "1px solid #cbd5e1",

              borderRadius:
                14,

              background:
                "#ffffff",

              color:
                "#334155",

              fontWeight:
                600,

              cursor:
                "pointer",

              transition:
                ".2s",

              width:
                isMobile
                  ? "100%"
                  : "auto"
            }}

            onClick={
              onClose
            }
          >

            Cancelar

          </button>

          {/* ACCIONES */}

          <div
            style={{
              display:
                "flex",

              flexDirection:
                isMobile
                  ? "column-reverse"
                  : "row",

              gap:
                10,

              flexWrap:
                "wrap",

              width:
                isMobile
                  ? "100%"
                  : "auto"
            }}
          >

            {
              cita && (

                <button
                  style={{
                    height:
                      isMobile
                        ? 50
                        : 48,

                    padding:
                      "0 22px",

                    width:
                      isMobile
                        ? "100%"
                        : "auto",

                    border:
                      "none",

                    borderRadius:
                      14,

                    background:
                      "#dc2626",

                    color:
                      "#fff",

                    fontWeight:
                      700,

                    cursor:
                      "pointer",

                    transition:
                      ".2s"
                  }}

                  onClick={() => {
                    setShowDeleteAppointmentConfirm(true);
                  }}
                >

                  Eliminar

                </button>

              )
            }

            <button
              style={{
                height:
                  isMobile
                    ? 52
                    : 48,

                padding:
                  "0 28px",

                width:
                  isMobile
                    ? "100%"
                    : "auto",

                border:
                  "none",

                borderRadius:
                  14,

                background:
                  "#2563eb",

                color:
                  "#fff",

                fontWeight:
                  700,

                cursor:
                  "pointer",

                transition:
                  ".2s"
              }}

              disabled={guardandoCita || (modoFormulario === "cita" && !agendaLista)}
              onClick={
                confirmarGuardar
              }
            >

              {
                guardandoCita ? "Guardando cita…" : cita
                  ? "Guardar cambios"
                  : "Crear cita"
              }

            </button>

          </div>

        </div>

      </div>

      </div>

      {/* =========================
          NUEVO PACIENTE
      ========================= */}

      {
        showPacienteForm && (

          <PacienteForm
            onClose={() =>
              setShowPacienteForm(
                false
              )
            }

            onSaved={nuevo => {

              setPacienteSeleccionado(
                nuevo
              );

              setBusqueda(
                `${nuevo.nombre} ${nuevo.apellidos}`
              );

              setMostrarLista(
                false
              );

              setShowPacienteForm(
                false
              );

            }}
          />

        )
      }


      {/* =========================
          SELECTOR PERSONALIZADO DE HORA
      ========================= */}

      {mostrarSelectorHora && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 1000002,
            background: "rgba(15,23,42,.55)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 20
          }}
        >
          <div
            role="dialog"
            aria-modal="true"
            aria-label="Seleccionar hora de la cita"
            style={{
              width: "100%",
              maxWidth: 360,
              background: "#fff",
              borderRadius: 20,
              padding: 24,
              boxSizing: "border-box",
              boxShadow: "0 24px 70px rgba(0,0,0,.25)"
            }}
          >
            <h3
              style={{
                margin: "0 0 8px",
                color: "#111827",
                fontSize: 20
              }}
            >
              Seleccionar hora
            </h3>

            <p
              style={{
                margin: "0 0 20px",
                color: "#64748b",
                fontSize: 14
              }}
            >
              Elige la hora, los minutos y el periodo.
            </p>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                gap: 10
              }}
            >
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: 6,
                    fontSize: 12,
                    fontWeight: 700,
                    color: "#475569"
                  }}
                >
                  Hora
                </label>

                <select
                  value={horaSelector}
                  onChange={e =>
                    setHoraSelector(e.target.value)
                  }
                  style={{
                    ...inputStyle,
                    minHeight: 44,
                    padding: 8
                  }}
                >
                  {Array.from(
                    { length: 12 },
                    (_, i) => String(i + 1)
                  ).map(hora => (
                    <option key={hora} value={hora}>
                      {hora}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: 6,
                    fontSize: 12,
                    fontWeight: 700,
                    color: "#475569"
                  }}
                >
                  Minutos
                </label>

                <select
                  value={minutoSelector}
                  onChange={e =>
                    setMinutoSelector(e.target.value)
                  }
                  style={{
                    ...inputStyle,
                    minHeight: 44,
                    padding: 8
                  }}
                >
                  {Array.from(
                    { length: 60 },
                    (_, i) => String(i).padStart(2, "0")
                  ).map(minuto => (
                    <option key={minuto} value={minuto}>
                      {minuto}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: 6,
                    fontSize: 12,
                    fontWeight: 700,
                    color: "#475569"
                  }}
                >
                  Periodo
                </label>

                <select
                  value={periodoSelector}
                  onChange={e =>
                    setPeriodoSelector(e.target.value)
                  }
                  style={{
                    ...inputStyle,
                    minHeight: 44,
                    padding: 8
                  }}
                >
                  <option value="AM">AM</option>
                  <option value="PM">PM</option>
                </select>
              </div>
            </div>

            <div
              style={{
                margin: "20px 0",
                padding: 16,
                borderRadius: 12,
                background: "#eff6ff",
                textAlign: "center",
                color: "#1d4ed8",
                fontSize: 28,
                fontWeight: 800
              }}
            >
              {horaSelector}:{minutoSelector} {periodoSelector}
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 10
              }}
            >
              <button
                type="button"
                onClick={() =>
                  setMostrarSelectorHora(false)
                }
                style={{
                  minHeight: 46,
                  border: "1px solid #cbd5e1",
                  borderRadius: 11,
                  background: "#fff",
                  color: "#475569",
                  fontWeight: 700,
                  cursor: "pointer"
                }}
              >
                Cancelar
              </button>

              <button
                type="button"
                onClick={() => {
                  const hora12 = Number(horaSelector);

                  const hora24 =
                    (hora12 % 12) +
                    (periodoSelector === "PM" ? 12 : 0);

                  const horaConfirmada =
                    `${String(hora24).padStart(2, "0")}:${minutoSelector}`;

                  setConflictoAceptadoKey("");
                  setMostrarSelectorHora(false);

                  setForm(actual => ({
                    ...actual,
                    hora: horaConfirmada
                  }));
                }}
                style={{
                  minHeight: 46,
                  border: "none",
                  borderRadius: 11,
                  background: "#2563eb",
                  color: "#fff",
                  fontWeight: 700,
                  cursor: "pointer"
                }}
              >
                Confirmar hora
              </button>
            </div>
          </div>
        </div>
      )}

      {/* =========================
          ALERTA DE HORARIO OCUPADO
      ========================= */}

      {mostrarAlertaHorario && alertaParaKey === horarioActualKey && conflictosHorario.length > 0 && !guardandoCita && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 1000001,
            background: "rgba(15,23,42,.55)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 18
          }}
        >
          <div
            role="dialog"
            aria-modal="true"
            style={{
              width: "100%",
              maxWidth: 460,
              maxHeight: "90dvh",
              overflowY: "auto",
              background: "#fff",
              borderRadius: 20,
              padding: isMobile ? 20 : 24,
              boxShadow: "0 24px 70px rgba(0,0,0,.25)",
              boxSizing: "border-box"
            }}
          >
            
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                marginBottom: 14
              }}
            >
              <div
                style={{
                  width: 44,
                  height: 44,
                  borderRadius: 13,
                  background: "#fef3c7",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0
                }}
              >
                <AlertTriangle size={24} color="#b45309" />
              </div>

              <div style={{ flex: 1, minWidth: 0 }}>
                <h3
                  style={{
                    margin: 0,
                    color: "#111827",
                    fontSize: 19
                  }}
                >
                  Horario ocupado
                </h3>

                <div
                  style={{
                    marginTop: 4,
                    color: "#64748b",
                    fontSize: 13
                  }}
                >
                  {form.fecha} · {form.hora}
                </div>
              </div>

              <button
                type="button"
                aria-label="Cerrar alerta de horario ocupado"
                onClick={() => {
                  setMostrarAlertaHorario(false);
                  setMostrarAlternativasHorario(false);
                }}
                style={{
                  width: 36,
                  height: 36,
                  minWidth: 36,
                  border: "none",
                  borderRadius: 10,
                  background: "#f1f5f9",
                  color: "#475569",
                  fontSize: 23,
                  lineHeight: 1,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                ×
              </button>
            </div>

            <p
              style={{
                color: "#475569",
                fontSize: 14,
                lineHeight: 1.55,
                margin: "0 0 16px"
              }}
            >
              {conflictosHorario.some(
                conflicto =>
                  conflicto.tipo === "bloqueoAgenda"
              )
                ? "El horario seleccionado coincide con un bloqueo de agenda o con una cita existente."
                : `Ya existe ${
                    conflictosHorario.length === 1
                      ? "una cita"
                      : `${conflictosHorario.length} citas`
                  } que coincide con ese horario o se traslapa con la duración seleccionada.`}
            </p>

            {mostrarAlternativasHorario && (
              <div style={{ marginBottom: 18 }}>
                <div
                  style={{
                    fontSize: 13,
                    fontWeight: 700,
                    color: "#334155",
                    marginBottom: 9
                  }}
                >
                  Horarios disponibles cercanos
                </div>

                {alternativasHorario.length > 0 ? (
                  <div style={{ display: "grid", gap: 8 }}>
                    {alternativasHorario.map(opcion => (
                      <button
                        key={`${opcion.fecha}-${opcion.hora}`}
                        type="button"
                        onClick={() => {
                          setConflictoAceptadoKey("");

                          setForm(actual => ({
                            ...actual,
                            fecha: opcion.fecha,
                            hora: opcion.hora
                          }));

                          setMostrarAlertaHorario(false);
                          setMostrarAlternativasHorario(false);
                        }}
                        style={{
                          width: "100%",
                          minHeight: 44,
                          border: "1px solid #bfdbfe",
                          borderRadius: 11,
                          background: "#eff6ff",
                          color: "#1d4ed8",
                          fontWeight: 700,
                          cursor: "pointer"
                        }}
                      >
                        {opcion.hora}
                      </button>
                    ))}
                  </div>
                ) : (
                  <div
                    style={{
                      padding: 12,
                      borderRadius: 10,
                      background: "#f8fafc",
                      color: "#64748b",
                      fontSize: 13,
                      lineHeight: 1.5
                    }}
                  >
                    No encontré horarios libres cercanos ese día. Puedes cambiar la hora manualmente o continuar con la selección actual.
                  </div>
                )}
              </div>
            )}

            <div style={{ display: "grid", gap: 9 }}>
              <button
                type="button"
                onClick={() =>
                  setMostrarAlternativasHorario(value => !value)
                }
                style={{
                  minHeight: 46,
                  border: "1px solid #2563eb",
                  borderRadius: 11,
                  background: "#eff6ff",
                  color: "#1d4ed8",
                  fontWeight: 700,
                  cursor: "pointer"
                }}
              >
                {mostrarAlternativasHorario
                  ? "Ocultar horarios disponibles"
                  : "Ver horarios disponibles"}
              </button>

              <button
                type="button"
                disabled={conflictosHorario.some(
                  conflicto =>
                    conflicto.tipo === "bloqueoAgenda"
                )}
                onClick={() => {
                  setConflictoAceptadoKey(horarioActualKey);

                  setMostrarAlertaHorario(false);
                  setMostrarAlternativasHorario(false);
                }}
                style={{
                  minHeight: 46,
                  border: "none",
                  borderRadius: 11,
                  background: conflictosHorario.some(
                    conflicto =>
                      conflicto.tipo === "bloqueoAgenda"
                  )
                    ? "#94a3b8"
                    : "#2563eb",
                  color: "#fff",
                  fontWeight: 700,
                  cursor: conflictosHorario.some(
                    conflicto =>
                      conflicto.tipo === "bloqueoAgenda"
                  )
                    ? "not-allowed"
                    : "pointer"
                }}
              >
                Agendar de todos modos
              </button>
            </div>
          </div>
        </div>
      )}

      {/* =========================
          CONFIRMAR GUARDADO
      ========================= */}

      <ConfirmDialog
        open={
          showConfirm
        }

        title={
          cita
            ? "Guardar cambios"
            : "Nueva cita"
        }

        message={
          cita
            ? "¿Deseas guardar los cambios realizados en esta cita?"
            : "¿Deseas crear esta cita?"
        }

        confirmText={
          cita
            ? "Guardar"
            : "Crear cita"
        }

        cancelText="Cancelar"

        onCancel={() =>
          setShowConfirm(
            false
          )
        }

        onConfirm={
          async () => {

            setShowConfirm(
              false
            );

            await guardar();

          }
        }
      />

      <ConfirmDialog
        open={showDeleteBlockConfirm}
        title="Eliminar bloqueo de agenda"
        message={
          "¿Estás seguro de que deseas eliminar este bloqueo? " +
          "El horario volverá a estar disponible para agendar citas."
        }
        confirmText={
          eliminandoBloqueo
            ? "Eliminando..."
            : "Sí, eliminar bloqueo"
        }
        cancelText="Cancelar"
        onCancel={() => {
          if (!eliminandoBloqueo) {
            setShowDeleteBlockConfirm(false);
          }
        }}
        onConfirm={eliminarBloqueo}
      />

      <ConfirmDialog
        open={showDeleteAppointmentConfirm}
        title="Eliminar cita"
        message="¿Estás seguro de que deseas eliminar esta cita definitivamente? Esta acción no se puede deshacer."
        confirmText="Sí, eliminar cita"
        cancelText="Cancelar"
        onCancel={() => {
          setShowDeleteAppointmentConfirm(false);
        }}
        onConfirm={async () => {
          setShowDeleteAppointmentConfirm(false);
          await eliminar();
        }}
      />

      {/* =========================
          ADVERTENCIA FECHA ANTERIOR
      ========================= */}

      {
        showPastDateWarning && (

          <div
            style={{
              position:
                "fixed",

              inset:
                0,

              background:
                "rgba(15, 23, 42, 0.45)",

              display:
                "flex",

              alignItems:
                "center",

              justifyContent:
                "center",

              zIndex:
                1000000,

              padding:
                20
            }}
          >

            <div
              style={{
                width:
                  "100%",

                maxWidth:
                  430,

                background:
                  "#ffffff",

                borderRadius:
                  20,

                padding:
                  24,

                boxShadow:
                  "0 20px 50px rgba(0,0,0,0.20)"
              }}
            >

              {/* ENCABEZADO */}

              <div
                style={{
                  display:
                    "flex",

                  alignItems:
                    "flex-start",

                  gap:
                    14,

                  marginBottom:
                    18
                }}
              >

                <div
                  style={{
                    width:
                      46,

                    height:
                      46,

                    borderRadius:
                      14,

                    background:
                      "#fef3c7",

                    display:
                      "flex",

                    alignItems:
                      "center",

                    justifyContent:
                      "center",

                    flexShrink:
                      0
                  }}
                >

                  <AlertTriangle
                    size={25}
                    color="#d97706"
                    strokeWidth={2.2}
                  />

                </div>

                <div>

                  <h3
                    style={{
                      margin:
                        0,

                      fontSize:
                        19,

                      fontWeight:
                        700,

                      color:
                        "#111827"
                    }}
                  >

                    Fecha anterior

                  </h3>

                  <p
                    style={{
                      margin:
                        "7px 0 0",

                      fontSize:
                        14,

                      lineHeight:
                        1.5,

                      color:
                        "#64748b"
                    }}
                  >

                    La fecha seleccionada es anterior a hoy.

                  </p>

                </div>

              </div>

              {/* MENSAJE */}

              <div
                style={{
                  background:
                    "#f8fafc",

                  border:
                    "1px solid #e2e8f0",

                  borderRadius:
                    14,

                  padding:
                    15,

                  marginBottom:
                    22,

                  fontSize:
                    14,

                  lineHeight:
                    1.55,

                  color:
                    "#475569"
                }}
              >

                Esta cita se registrará en un día anterior a la fecha actual.

                <br />

                <strong
                  style={{
                    display:
                      "block",

                    marginTop:
                      5,

                    color:
                      "#1e293b"
                  }}
                >

                  ¿Deseas continuar?

                </strong>

              </div>

              {/* BOTONES */}

              <div
                style={{
                  display:
                    "flex",

                  justifyContent:
                    "flex-end",

                  gap:
                    10
                }}
              >

                <button
                  type="button"

                  onClick={() => {

                    setShowPastDateWarning(
                      false
                    );

                  }}

                  style={{
                    height:
                      44,

                    padding:
                      "0 18px",

                    border:
                      "1px solid #cbd5e1",

                    borderRadius:
                      10,

                    background:
                      "#ffffff",

                    color:
                      "#334155",

                    fontWeight:
                      600,

                    cursor:
                      "pointer"
                  }}
                >

                  Cancelar

                </button>

                <button
                  type="button"

                  onClick={
                    async () => {

                      setShowPastDateWarning(
                        false
                      );

                      await guardar(
                        true,
                        !abrirEvolucionAlGuardarRef.current
                      );

                    }
                  }

                  style={{
                    height:
                      44,

                    padding:
                      "0 18px",

                    border:
                      "none",

                    borderRadius:
                      10,

                    background:
                      "#2563eb",

                    color:
                      "#ffffff",

                    fontWeight:
                      700,

                    cursor:
                      "pointer"
                  }}
                >

                  Agendar de todos modos

                </button>

              </div>

            </div>

          </div>

        )
      }

    </div>,
    document.body
  );
}
